import React, {PureComponent, ReactNode} from 'react';
import I18n from 'app/i18n';
import {PopupDialog} from 'app/utils/modals/PopupDialog';
import BonusInterface from 'app/interfaces/BonusInterface';
import BonusesCard from 'app/components/my_profile/bonuses/BonusesCard';
import {getLinkPath, goToRoute} from 'app/utils';
import {toastError} from 'app/components/toasts/liteToast';
import {modalsStore} from 'app/store/global';


interface PopupBonusesProps {
    bonus: BonusInterface;
    hasActiveBonus: boolean;
    popupId: string;
    activateBonus: (id: number) => void;
    showNotViewedBonusPopup: (force?: boolean) => void;
}

export default class PopupBonuses extends PureComponent<PopupBonusesProps> {
    handleActivateBonus = (): void => {
        const {bonus, hasActiveBonus, popupId, activateBonus} = this.props;

        goToRoute(getLinkPath('/my_profile/bonuses'));
        modalsStore.hideModal(popupId);

        if (hasActiveBonus) {
            toastError(I18n.t('bonuses_page.error_cancel_current_bonus'));
            return;
        }

        activateBonus(bonus.id);
    };

    onClose = (): void => {
        this.props.showNotViewedBonusPopup(true);
    };

    render(): ReactNode {
        const {bonus, popupId} = this.props;

        return (
            <PopupDialog id={popupId} setFocus onClose={this.onClose}>
                <div className="popup__content">
                    <div className="bonuses-congratulation">
                        <h3 className="bonuses-congratulation__title">{I18n.t('bonuses_received')}</h3>
                        <div className="bonuses-congratulation__content">
                            <BonusesCard {...bonus} />
                            <button
                                className="button-adaptive bonuses-congratulation__button"
                                onClick={this.handleActivateBonus}
                            >
                                {I18n.t('activate')}
                            </button>
                        </div>
                        <div className="bonuses-congratulation__background">
                            <div className="bonuses-congratulation__line"></div>
                            <div className="bonuses-congratulation__semi-spehere-wrapper">
                                <div className="bonuses-congratulation__semi-spehere"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </PopupDialog>
        );
    }
}
